import React from "react";
import { Typography, makeStyles, useTheme } from "@material-ui/core";
import WebApi from "api/ApiConstants";
import OaLoading from "pages/components/OaLoading";
import OaSnackbar from "oahoc/OaSnackbar";
import OaPopperAlert from "oahoc/OaPopperAlert";
import { CheckCircle, ErrorOutlineRounded } from "@material-ui/icons";
import { NSDL_NEW_PAN_REQUEST } from "api/ApiConstants";
import { NSDL_PROCESS_RESPONSE } from "api/ApiConstants";
import { EXT_REDIRECT_SERVER } from "api/ApiConstants";

const PanPaymentStatus = (props) => {
    const theme = useTheme();
    const classes = useStyles();
    const [isLoading, setIsLoading] = React.useState(true);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [finalFormData, setFinalFormData] = React.useState(null);
    const [paymentSuccess, setPaymentSuccess] = React.useState(false);
    const [refId, setRefId] = React.useState(props?.match?.params?.tid);
    const [trnRequest, setTrnRequest] = React.useState(null);

    const [severity, setSeverity] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });
    const [severitySnackbar, setSeveritySnackbar] = React.useState({
        issuccess: false,
        iserror: false,
        iswarning: false,
        isinfo: false
    });

    const submitData = (txnId, reqParam) => {
        WebApi.nsdlSignRequest({
            formData: JSON.stringify(reqParam),
            redirectUrl: NSDL_PROCESS_RESPONSE,
            siteUrl: EXT_REDIRECT_SERVER + "pan/application/response/",
            requestType: "CR",
            txnId: txnId
        }, response => {
            if(response.success) {
                setFinalFormData(response.data);
                setAlertMessage("Processing application form for submission...");
                setSeveritySnackbar({
                    ...severitySnackbar,
                    issuccess: true
                });
            } else {
                console.log("error response", response);
                setAlertMessage(response.message);
                setSeverity({
                    ...severity,
                    iserror: true
                });
            }
        }, error => {
            console.log("error", error);
        });
    };

    const submitToNsdl = () => {
        var formElement = document.createElement("form");
        formElement.setAttribute("method", "post");
        formElement.setAttribute("action", NSDL_NEW_PAN_REQUEST);
        formElement.setAttribute("target", "_parent");

        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", "req");
        hiddenField.setAttribute("value", finalFormData);
        formElement.appendChild(hiddenField);

        document.body.appendChild(formElement);
        formElement.submit();
    }

    React.useEffect(() => {
        WebApi.nsdlPanGetTransaction({
            txnId: props?.match?.params?.tid
        }, response => {
            setIsLoading(false);
            if(response.success) {
                const txnId = response.data.txnId;
                const requestData = response.data;
                delete requestData.applicationType;
                delete requestData.paymentMode;
                delete requestData.tempTokenNo;
                delete requestData.loggedInUserId;
                delete requestData.userType;
                delete requestData.partnerId;
                delete requestData.txnId;
                delete requestData.requestType;
                delete requestData.redirectUrl;
                delete requestData.siteUrl;
                delete requestData.encTxnId;
                delete requestData.amountDue;
                delete requestData.applicantDto.id;
                delete requestData.applicantDto.tid;
                delete requestData.applicantDto.created_at;
                delete requestData.parentsDetails.tid;
                delete requestData.parentsDetails.token_number;
                delete requestData.otherDetails.tid;
                delete requestData.otherDetails.token_number;
                delete requestData.otherDetails.sourceOfIncome.tid;
                delete requestData.otherDetails.sourceOfIncome.token_number;
                delete requestData.otherDetails.officeAddress.tid;
                delete requestData.otherDetails.officeAddress.token_number;
                delete requestData.otherDetails.raAddress.tid;
                delete requestData.otherDetails.raAddress.token_number;
                delete requestData.otherDetails.residenceAddress.tid;
                delete requestData.otherDetails.residenceAddress.token_number;
                delete requestData.parentsDetails.tid;
                delete requestData.parentsDetails.token_number;
                requestData.aoCode = {
                    areaCode: "",
                    aoType: "",
                    rangeCode: "",
                    aoNo: ""
                };
                submitData(txnId, requestData);
                setPaymentSuccess(true);
            }
        }, error => { 
            console.log("error", error);
            setIsLoading(false);
            setAlertMessage("Error getting application data");
            setSeveritySnackbar({
                ...severitySnackbar,
                iserror: true
            });
        });
    }, []);

    React.useEffect(() => {
        if(finalFormData && finalFormData !== "") {
            submitToNsdl();
        }
    }, [finalFormData]);

    return(
        !isLoading ? 
        <>
        <div className={classes.root}>
            <div className="section-container" style={{ paddingBottom: "8px" }}>
                <div className="icon-group">
                    {paymentSuccess ?
                        <CheckCircle style={{ color: theme.palette.primary.success }}/> : 
                        <ErrorOutlineRounded style={{ color: "orange" }} />}
                    <Typography>
                        Reference id : <b>{refId}</b>
                    </Typography>
                    <Typography>
                        Status : <b>{paymentSuccess ? "Success" : "Failed"}</b>
                    </Typography>
                    <Typography>
                        {paymentSuccess ? "" : "Error encountered, please contact admin for transaction id " + refId}
                    </Typography>
                </div>
            </div>
        </div>
        <OaPopperAlert
            alertmessage={alertMessage}
            severity={severity}
            setseverity={setSeverity}
        />
        <OaSnackbar
            alertmessage={alertMessage}
            severity={severitySnackbar}
            setseverity={setSeveritySnackbar}
            vertical="bottom"
            horizontal="right"
            autoHideDuration={6000}
        />
        </>
        :
        <div className={classes.loadingRoot}>
            <OaLoading />
        </div>
    );
};

export default PanPaymentStatus;

const useStyles = makeStyles(theme => ({
    root: {
        "& .section-container": {
            paddingBottom: 8,
            display: "flex",
            height: "60vh",
            alignItems: "center",
            justifyContent: "center",
        },
        "& .icon-group": {
            textAlign: "center",
            "& .MuiSvgIcon-root": {
                fontSize: "6.5rem",
            }
        },
    },
    loadingRoot: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
    },
}));
